import repository from "../Repository";

export default {
  async getList(screenId) {
    const res = await repository.post(
      `bus_mst_info`,
      {},
      { headers: { s: screenId } }
    );
    return res;
  }
};
